import styled from "styled-components"
import regist from '@/img/user-new/button-yellow.png'
import close from '@/img/user-new/close.png'
import titileBack from '@/img/user-new/title-blue.png'
import buttonSumbit from '@/img/value-investment/button-sumbit.png'
import home_bg from '@/img/value-investment/home_bg.png'
export const ShareContainer = styled.div`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e6f3fc 100%);
  position: relative;
  .container {
    background-image: url('https://file.wogoo.com/image/activity/user-background-1.png'), url('https://file.wogoo.com/image/activity/user-background-2.png');
    background-repeat: no-repeat, no-repeat;
    background-size: 100%, 100%;
    background-position: top left, bottom left;
    height: 503.7vw;
    position: relative;
    padding: 97.33vw 15px 87px;
    box-sizing: border-box;
  }
  &.value-container {
    .container {
      background-image: url('https://file.wogoo.com/image/activity/value-background-8.png'), url('https://file.wogoo.com/image/activity/value-background-9.png');
      background-repeat: no-repeat, no-repeat;
      background-size: 100%, 100%;
      background-position: top left, bottom left;
      height: 478.9vw;
      position: relative;
      padding: 124.47vw 15px 87px;
      box-sizing: border-box;
    }
  }
  &.value-container.value_active11 {
    .container {
      background-image: url(${home_bg}), url('https://file.wogoo.com/image/activity/value-background-9.png');
    }
  }
`
export const RegistContainer = styled.div`
  width: 100%;
  height: 223px;
  border-radius: 16px;
  box-shadow: 0px 2px 12px 0px rgba(42, 7, 103, .11);
  background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, #fff 100%);
  backdrop-filter: blur(4px);
  padding: 18px;
  box-sizing: border-box;
  &.value{
    height: 243px;
    padding: 12px 18px;
  }
  .container{
    width: 100%;
    padding: 24px;
    display: ${props=>props.Empty? 'flex':'block '};
    justify-content: center;
    align-items: ${props=>props.Empty?  'baseline':'center'};
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 2px 16px 0px rgba(255, 140, 137, 0.34);
    border-radius: 16px;
  }
  .name-container{
    margin-bottom: 11px;
  }
  .name{
    display: flex;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    color: #fe360c;
    line-height: 28px;
    z-index: 999;
    text-align: center;
  }
  .info{
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
    line-height: 26px;
    text-align: justify;
  }
`

export const FormCotainer = styled.div`
  .form-item{
    margin: 12px 0;
    padding: 14px 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    background: #fff;
    border-radius: 6px;
    &:first-child {
      margin-top: 0;
    }
    .am-list-item{
      width: 100%;
    }
    .am-list-item:not(:last-child) .am-list-line::after{
      background-color: transparent;
    }
    .am-list-item:not(:last-child) .am-list-line {
      border: none;
    }
    .am-list-item .am-input-clear{
      background-image: url(${close});
      background-color: transparent;
      background-size : 16px;
      width: 16px;
      height: 16px;
      background-position: 0 0;
      border-radius: 0;
    }
    .button{
      margin-left: 10px;
      width: 94px;
      text-align: right;
      background: #fff;
      border: none;
      outline: none;
      color: #9696A6;
    }
    .active{
      color: #ffb000;
    }
  }
  .am-list-item.am-input-item{
    padding-left: 2px;
  }
  .am-list-item{
    background: #fff;
    .am-input-label{
      width: 32px;
      font-size: 14px;
      color: #333;
    }
    .am-input-control input {
      font-size: 16px;
      color: #333;
    }
    .am-input-label{
      position: relative;
      overflow: visible;
    }
    .am-input-label:before{
      position: absolute;
      content: '';
      right: -1px;
      top: -2px;
      width: 1px;
      height: 24px;
      background: #979797;
      transform: scale(0.8);
      opacity: .32;
    }
  }
  .text{
      flex: 1;
      background: #fff;
      border: none;
      outline: none;
      .am-input-control input{
        font-size: 14px;
      }
    }
  .regist{
    margin-top: 6px; 
    width: 100%;
    height: 58px;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    color: #c65c00;
    background: url(${regist}) no-repeat center;
    background-size: 100%;
    letter-spacing: 2px;
  }
  .regist-desc {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #427cff;
    font-weight: 500;
  }
`

export const ActivityDesc = styled.div`
  position: absolute;
  top: 20vw;
  right: 0;
  color: #fff;
  line-height: 15px;
  font-size: 12px;
  transform: scale(.91);
  background: linear-gradient(180deg, #a59dff 0%, #1258f1 100%);
  width: 24px;
  height: 72px;
  text-align: center;
  padding: 6px 3px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  box-sizing: border-box;
  z-index: 1;
`

export const Ctitle = styled.div`
  .prize-header {
    height: 81px;
    position: absolute;
    top: -74px;
    left: 50%;
    transform: translateX(-50%);
  }
  .blue-back {
    width: calc(100% - 62px);
    height: 10px;
    position: absolute;
    top: 0;
    left: 31px;
    overflow: hidden;
    &::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 29px;
      border-radius: 15px;
      background-color: #17357c;
    }
  }
  .title {
    background-image: url(${titileBack});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 45px;
    right: 45px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #fff;
    font-weight: 600;
  }
`

export const Descp = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 20px;
  text-align: justify;
  .text-l {
    text-align: left;
  }
`

export const Cicon = styled.img`
  position: absolute;
  bottom: -45px;
  z-index: 99999;
  width: 30px;
  left: 50%;
  margin-left: -15px;
`

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 80px;
  padding: 15px 30px 10px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, .4);
  backdrop-filter: blur(7px);
  &.display {
    display: none;
  }
  .button {
    color: #c65c00;
    background: url(${regist}) no-repeat center;
    background-size: 100%;
    font-size: 16px;
    line-height: 55px;
    text-align: center;
    letter-spacing: 1px;
    font-weight: 500;
  }
`

export const Center = styled.div`
  text-align: center;
  .img {
    width: 170px;
    margin-top: 19px;
  }
  .desc {
    margin-top: 16px;
    color: #9696a6;
    line-height: 17px;
    font-size: 12px;
  }
`

export const RegistModalContent = styled.div`
  .regist-modal-content-text{
    text-align: center∂;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #333;
  }
  .regist-modal-content-group{
    margin: 24px auto 0;
    display: flex;
    justify-content: space-around;
  }
  .regist-modal-content-button{
    width: 100%;
    font-size: 14px;
    text-align: center;
    line-height: 54px;
    color: #c65c00;
    font-weight: 500;
    border-radius: 20px;
    border:none;
    background: url(${regist}) no-repeat center;
    background-size: 100%;
  }
  .regist-modal-button{
    width: 100%;
    display: flex;
    align-items: center;
    .regist-modal-close{
      width: calc(50% - 7px);
      height: 42px;
      background-image: url(${buttonSumbit});
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 40px;
      color: #c65c00;
      font-size: 14px;
      font-weight: 500;
    }
  }
    
`


// WEBPACK FOOTER //
// ./src/views/user-new/regist/style.js